import { schedule } from '@ember/runloop';

import { fetchFeedProfile, getProfileFeed } from 'mewe/fetchers/fetch-feed';
import Route from 'mewe/routes/route';
import { inject as service } from '@ember/service';

const hasId = (str) => str && str.indexOf('id=') > -1;

export default Route.extend({
  theme: 'profile',
  router: service(),
  dynamicDialogs: service(),

  queryParams: {
    tag: {
      refreshModel: true,
    },
  },

  beforeModel(transition) {
    if (transition.to.queryParams.id) {
      this.router.replaceWith('/' + transition.to.queryParams.id);
    }

    this.previousRouteName = transition.from?.name;
  },

  model: function (routeParams, transition) {
    let { to: toRouteInfo } = transition;
    let tag = toRouteInfo.queryParams.tag;
    const params = this.modelFor('app.publicid') || {};

    // uuid won't be present when user data can't be fetched (e.g. blocked user)
    if (!params.uuid) return {};

    fetchFeedProfile(params.uuid, { limit: 5, hashtag: tag });

    return {
      contact: this.modelFor('app.publicid').contact,
      feed: getProfileFeed(params.uuid),
      chatState: this.modelFor('app') ? this.modelFor('app').chats : {},
      tag: tag,
      isMyProfile: this.modelFor('app.publicid').isMyProfile,
      isPublic: this.modelFor('app.publicid').isPublic,
      isFollowing: this.modelFor('app.publicid').isFollowing,
    };
  },

  activate() {
    this._super();

    const profileParams = this.paramsFor('app.publicid');
    const profileModel = this.modelFor('app.publicid');

    const inviteId = profileParams && profileParams.id;

    if (hasId(inviteId) && profileModel && profileModel.inviteId) {
      schedule('afterRender', this, function () {
        window.history.replaceState({}, document.title, '/i/' + profileModel.inviteId);
      });
    }
  },

  actions: {
    willTransition(transition) {
      // prevent uloading posts when navigating to the same profile's parent route (SG-39533)
      if (transition.to.name === 'app.publicid.index') {
        const currentProfileId = this.modelFor('app.publicid').contact.publicLinkId;
        const targetProfileId = transition.to.parent.params.id;
        if (currentProfileId === targetProfileId) {
          transition.abort();
        }
      }

      if (this.controller.tag) {
        this.controller.set('tag', null);
        history.replaceState('', document.title, window.location.pathname); // prevent loading feed for tag on back navigation
      }
    },

    didTransition() {
      // don't close dialogs on initial load, we might want to show a popup on start
      if (this.previousRouteName) {
        this.dynamicDialogs.closeAll();
      }

      window.scrollTo(0, 0);
    },
  },
});
